/**
 * Утиліта для формування canonical URL (path-based).
 *
 * Якщо є категорія — бренд і модель йдуть у path:
 *   /zapchastyny/:category[/:brand[/:model]]
 * Якщо категорії немає — бренд і модель як query params:
 *   /zapchastyny?brand=...&model=...
 * Рік, двигун, ціна, inStock, пагінація — НЕ включаються.
 *
 * @param {string|null} categoryParam - Slug категорії з useParams
 * @param {string|null} brandParam    - Slug бренду з useParams
 * @param {string|null} modelParam    - Slug моделі з useParams
 * @param {URLSearchParams} searchParams - Query params поточного URL
 * @returns {string} Canonical URL
 */
export const getCanonicalUrl = (categoryParam, brandParam, modelParam, searchParams) => {
    if (categoryParam) {
        let base = `/zapchastyny/${categoryParam}`;
        if (brandParam) {
            base += `/${brandParam}`;
            if (modelParam) base += `/${modelParam}`;
        }
        return base;
    }

    // Без категорії — brand/model у query params
    const base = '/zapchastyny';
    const params = new URLSearchParams();
    const brand = brandParam || searchParams.get('brand');
    const model = modelParam || searchParams.get('model');
    if (brand) params.append('brand', brand);
    if (model) params.append('model', model);

    const qs = params.toString();
    return qs ? `${base}?${qs}` : base;
};


